<template>
    
</template>

<script>
    export default {
        name: "sharecommon"
    }
</script>

<style scoped>

</style>